export default {
  appEnabled: state => !!state.config.app_enabled
}
